import ViewBase from "../../../../framework/core/mvvm/view_base";
import LanguageManager from "../../../../manager/language_manager";
import * as QRCode from "../../../../qrcode/qrcode"
import TimeManager from "../../../../manager/time_manager";
import GameUtil from "../../../../utility/game_util";
import AppData from "../../../public/const/app_data";
const { ccclass, property } = cc._decorator;

@ccclass
export default class PromoteView extends ViewBase {
    @property(cc.Node)
    sharePenel:cc.Node = null

    @property(cc.Sprite)
    myHeadSpr:cc.Sprite = null

    @property(cc.Label)
    myNameLab:cc.Label = null
    
    @property(cc.Label)
    myInviteCode:cc.Label = null

    @property(cc.Node)
    togInformation:cc.Node = null

    @property(cc.Node)
    inviteBtn:cc.Node = null

    @property(cc.Label)
    promoteTime:cc.Label = null //时间

    @property(cc.Label)
    totalAward:cc.Label = null //总的奖励金额

    @property(cc.Label)
    rewardBalance:cc.Label = null //可提现余额

    @property(cc.Label)
    shareQrcodeLab:cc.Label = null

    @property(cc.Node)
    shareQrcode:cc.Node = null

    @property(cc.Node)
    shareNode:cc.Node = null

    @property(cc.Node)
    ruleQrcode:cc.Node = null

    @property(cc.Node)
    mainAdDNode:cc.Node = null

    @property(cc.Node)
    mainPlayerNode:cc.Node = null

    @property(cc.Sprite)
    mainPlayerIcon:cc.Sprite = null

    @property(cc.Label)
    mainPlayerID:cc.Label = null

    @property(cc.Label)
    mainPlayerName:cc.Label = null

    @property(cc.Node)
    mainFindNode:cc.Node = null

    @property(cc.EditBox)
    findInPut:cc.EditBox = null

    @property(cc.Sprite)
    ruleSpr:cc.Sprite = null

    @property(cc.Node)
    lvRuletTips:cc.Node = null

    @property(cc.Node)
    timeRuleTips:cc.Node = null 

    @property(cc.Node)
    withdrawalBtn:cc.Node = null

    @property(cc.Node)
    copyBtn:cc.Node = null

    @property(cc.Node)
    shareBtnNode : cc.Node = null;

    nowTime = 0
    promoteUrl = null

    //推广主界面
    showMainView(data, promotedata){
        this.myNameLab.string = data.name
        this.myInviteCode.string = data.inviteCode
        this.myHeadSpr.spriteFrame = data.avatarSprite
        //已经绑定邀请码
        //if (data.parentId > 0){
            this.togInformation.active = true
            this.inviteBtn.active = false
            this.copyBtn.active = true
            this.shareQrcodeLab.string = LanguageManager.t("promote_code") +  data.inviteCode
            this.mainAdDNode.active = false
            this.mainFindNode.active = true
            this.mainPlayerNode.active = false
            this.shareNode.active = true
            this.myInviteCode.node.parent.active = true
            this.shareBtnNode.active = !cc.sys.isBrowser;
            
        // }
        // else{
        //     this.myInviteCode.node.parent.active = false
        //     this.togInformation.active = false
        //     this.inviteBtn.active = true
        //     this.copyBtn.active = false
        //     this.mainAdDNode.active = true
        //     this.mainFindNode.active = false
        //     this.mainPlayerNode.active = false
        //     this.shareNode.active = false
        // }
     
        this.promoteUrl = promotedata.qrcode +  "?inviteCode=" + data.inviteCode
        AppData.promoteUrl = this.promoteUrl
        this.creatQrcode(this.ruleQrcode, this.promoteUrl)
        this.creatQrcode(this.shareQrcode, this.promoteUrl)
        this.node.active = true
    }


    //查看查找的玩家
    showFindPlayerInfo(playerData){
        if (playerData != null){
            this.mainFindNode.active = false
            this.mainPlayerName.string = playerData.name
            this.mainPlayerID.string = playerData.id
            this.mainPlayerIcon.spriteFrame = playerData.avatarSprite
            this.mainPlayerNode.active = true
        }
        else{
            this.mainFindNode.active = true
            this.mainPlayerNode.active = false
        }
    }



    //更新我的收益界面
    showMyRewardView(data){

        this.promoteTime.string = GameUtil.currencyFormatting(Number(data.lastWeekRewardGold)) //暂时在时间这显示
        this.totalAward.string = GameUtil.currencyFormatting(Number(data.totalRewardAmount))
        this.rewardBalance.string = GameUtil.currencyFormatting(Number(data.rewardBalance))   
    
        for (let index = 0; index < data.userPlayerDayList.length; index++) {
            const element = data.userPlayerDayList[index];
            let itemObj = cc.find("InfoPanels/Information/Item" + (index + 1), this.node)
            if (itemObj != null){
                let timeLab = cc.find("Time", itemObj).getComponent(cc.Label)
                let playerLab = cc.find("Player", itemObj).getComponent(cc.Label)
                let awardLab = cc.find("Award", itemObj).getComponent(cc.Label)
                timeLab.string = element.eventDateShow
                playerLab.string = element.canRewardUserNum
                awardLab.string = element.rewardAmount
            }
            
        }
    }

    updateShowTime(){
        this.nowTime -= 1
        if (this.nowTime <= 0){
            this.promoteTime.string = "00:00:00"
        }
        else{
            this.promoteTime.string = TimeManager.instance.getTimeLeft2BySecond(this.nowTime)
        }
    }

    //推广说明界面
    showRuleView(data){
        for (let index = 0; index < 6; index++) {
            const itemData = data.liftList[index];
            let itemObj = cc.find("InfoPanels/Rule/LvRule/Item" + (index + 1), this.node)
            if (itemObj != null){
                let nameLab = cc.find("LvCount", itemObj).getComponent(cc.Label)
                let playerLab = cc.find("PlyerCount", itemObj).getComponent(cc.Label)
                nameLab.string = itemData == null ? 0 : itemData.businessRewardLevelName
                playerLab.string = itemData == null ? 0 : itemData.canRewardUserNum
            }
            
        }


        //data.qrcode
        //data.backgroundUrl

    }

    //填写推广界面信息
    setPromoteAD(data){

    } 

    //生成二维码
    creatQrcode (qrcodeNode, url) {
        const qrcode = new QRCode(-1, 2);
        qrcode.addData(url);
        qrcode.make();
        let num = qrcode.getModuleCount();
        let uw = qrcodeNode.width / num;
        let uh = qrcodeNode.height / num;
        var g = qrcodeNode.getComponent(cc.Graphics);
        g.clear();
        for (let r = 0; r < num; ++r) {
            for (let c = 0; c < num; ++c) {
                let x = c;
                let y = num - r - 1;
                if (qrcode.isDark(r, c)) {
                    g.fillColor.fromHEX('#000000');
                }
                else {
                    g.fillColor.fromHEX('#ffffff');
                }
                let bx = -qrcodeNode.width * qrcodeNode.anchorX;
                let by = -qrcodeNode.height * qrcodeNode.anchorY;
                g.rect(bx + uw*x, by + uh*y, uw, uh);
                g.fill();
            }
        }
    }


}